module.exports = __webpack_public_path__ + "static/img/unit_list.b616a416.png";